export const path = {
  home: '/',
  transactions: '/transactions',
  login: '/login',
  setting: '/setting',
  products: '/products',
  cms: '/customerservice',
  notFound: '*'
}
